/*
 * @description  : 
 * @Author       : Junfeng Fu
 * @Date         : 2022-11-25 16:31:29
 * @LastEditors  : liuting
 * @LastEditTime : 2023-06-20 17:35:27
 */
const enterpriseId = 'syatmb'
const AllUrl = {
  'dev': {
    baseUrl: 'http://192.168.1.108:5007', // 接口调用ip
    uploadUrl: 'https://192.168.1.239:5012', // 资源上传ip
    resourceUrl: 'https://192.168.1.239:5544/', // 资源访问路径
    webUrl: 'https://192.168.1.106:6003/#/login/syatmb', // 个人中心
    studyPath: 'http://192.168.1.106:6002', // 学习子系统访问路径
    enterpriseNumber: `/login/${enterpriseId}`, // 单位名称
    showCompanyName: true // 是否显示单位名称 爱维译
  },
  'test': {
    baseUrl: 'http://192.168.1.220:5007', // 接口调用ip
    uploadUrl: 'http://192.168.1.220:10004', // 资源上传ip
    resourceUrl: 'http://192.168.1.220:9026/', // 资源访问路径
    webUrl: 'http://aets.peixun.csatmb.com/#/login/csatmb', // 网站访问地址
    // studyPath: 'http://192.168.1.220:7003', // 学习子系统访问路径
    studyPath: 'http://192.168.1.220:9028', // 学习子系统访问路径
    showCompanyName: true // 是否显示单位名称 爱维译
  },
  'pre': {
    // baseUrl: 'https://front.gateway.nwatmb.icao.caetp.cn', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.nwatmb.icao.caetp.cn', // 资源上传ip
    // resourceUrl: 'https://resource.nwatmb.icao.caetp.cn/', // 资源访问路径
    // webUrl: 'https://aets.nwatmb.icao.caetp.cn/#/login/syatmb', // 网站访问地址
    // studyPath: 'https://study.nwatmb.icao.caetp.cn', // 学习子系统访问路径
    baseUrl: 'https://avie.ltd:15013', // 接口调用ip
    uploadUrl: 'https://avie.ltd:15012', // 资源上传ip
    resourceUrl: 'https://avie.ltd:15544/', // 资源访问路径
    webUrl: `https://avie.ltd:15008/#/login/${enterpriseId}`, // 网站访问地址
    studyPath: 'https://avie.ltd:15010', // 学习子系统访问路径
    enterpriseNumber: `/login/${enterpriseId}`,
    showCompanyName: true // 是否显示单位名称 爱维译
  },
  'pro': {
    // baseUrl: 'https://front.gateway.csatmb.com', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.csatmb.com', // 资源上传ip
    // resourceUrl: 'https://resource.csatmb.com/', // 资源访问路径
    // webUrl: 'https://aets.peixun.csatmb.com/#/login/csatmb', // 网站访问地址
    // studyPath: 'http://study.csatmb.com', // 学习子系统访问路径
    // showCompanyName:true, //是否显示单位名称 爱维译

    // 复制的以前项目的
    // baseUrl: 'http://front.gateway.xinjiang.caetp.cn', // 接口调用ip
    // uploadUrl: 'http://uploadfiles.xinjiang.caetp.cn', // 资源上传ip
    // resourceUrl: 'http://resource.xinjiang.caetp.cn/', // 资源访问路径
    // webUrl: 'http://test.xinjiang.caetp.cn/#/login/csatmb', // 网站访问地址
    // studyPath: 'http://study.xinjiang.caetp.cn', // 学习子系统访问路径
    // showCompanyName:true, //是否显示单位名称 爱维译

    // 西南/首都机场试用
    // baseUrl: 'https://front.gateway.icao.caetp.cn', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.icao.caetp.cn', // 资源上传ip
    // resourceUrl: 'https://resource.icao.caetp.cn/', // 资源访问路径
    // webUrl: 'https://aets.peixun.icao.caetp.cn/#/login/csatmb', // 网站访问地址
    // studyPath: 'https://study.icao.caetp.cn', // 学习子系统访问路径
    // showCompanyName:true, //是否显示单位名称 爱维译

    // 中南
    // baseUrl: 'https://front.gateway.csatmb.com', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.csatmb.com', // 资源上传ip
    // resourceUrl: 'https://resource.csatmb.com/', // 资源访问路径
    // webUrl: 'https://aets.peixun.csatmb.com/#/login/csatmb', // 个人中心
    // studyPath: 'https://study.csatmb.com', // 学习子系统访问路径
    // showCompanyName: true // 是否显示单位名称 爱维译

    // 北京空管局
    // baseUrl: 'https://front.gateway.icao.caetn.cn', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.icao.caetn.cn', // 资源上传ip
    // resourceUrl: 'https://resource.icao.caetn.cn/', // 资源访问路径
    // webUrl: 'https://aets.peixun.icao.caetn.cn/#/login/login', // 个人中心
    // studyPath: 'https://study.icao.caetn.cn', // 学习子系统访问路径
    // enterpriseNumber: '/login/csatmb', // 单位名称
    // showCompanyName: true // 是否显示单位名称 爱维译

    // 西北
    // baseUrl: 'https://front.gateway.nwatmb.cn', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.nwatmb.cn', // 资源上传ip
    // resourceUrl: 'https://resource.nwatmb.cn/', // 资源访问路径
    // webUrl: 'https://nwatmb.cn/#/login/csatmb', // 个人中心
    // studyPath: 'https://study.nwatmb.cn', // 学习子系统访问路径
    // showCompanyName: true // 是否显示单位名称 爱维译

    // 三亚
    // baseUrl: 'https://front.gateway.icao.syatmb.com', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.icao.syatmb.com', // 资源上传ip
    // resourceUrl: 'https://resource.icao.syatmb.com/', // 资源访问路径
    // webUrl: 'https://syatmb.com/#/login/syatmb', // 个人中心
    // studyPath: 'https://study.icao.syatmb.com', // 学习子系统访问路径
    // enterpriseNumber: '/login/syatmb', // 单位名称
    // showCompanyName: true // 是否显示单位名称 爱维译
    syatmb: {//三亚
      baseUrl: 'https://front.gateway.icao.syatmb.com', // 接口调用ip
      uploadUrl: 'https://uploadfiles.icao.syatmb.com', // 资源上传ip
      resourceUrl: 'https://resource.icao.syatmb.com/', // 资源访问路径
      webUrl: 'https://syatmb.com/#/login/syatmb', // 个人中心
      studyPath: 'https://study.icao.syatmb.com', // 学习子系统访问路径
      enterpriseNumber: '/login/syatmb', // 单位名称
      showCompanyName: true // 是否显示单位名称 爱维译
    },
    csatmb: {//中南
      baseUrl: 'https://front.gateway.csatmb.com', // 接口调用ip
      uploadUrl: 'https://uploadfiles.csatmb.com', // 资源上传ip
      resourceUrl: 'https://resource.csatmb.com/', // 资源访问路径
      webUrl: 'https://aets.peixun.csatmb.com/#/login/csatmb', // 个人中心
      studyPath: 'https://study.csatmb.com', // 学习子系统访问路径
      enterpriseNumber: '/login/csatmb', // 单位名称
      showCompanyName: true // 是否显示单位名称 爱维译
    },
    nwatmb: {//西北
      baseUrl: 'https://front.gateway.nwatmb.cn', // 接口调用ip
      uploadUrl: 'https://uploadfiles.nwatmb.cn', // 资源上传ip
      resourceUrl: 'https://resource.nwatmb.cn/', // 资源访问路径
      webUrl: 'https://nwatmb.cn/#/login/nwatmb', // 个人中心
      studyPath: 'https://study.nwatmb.cn', // 学习子系统访问路径
      enterpriseNumber: '/login/nwatmb', // 单位名称
      showCompanyName: true // 是否显示单位名称 爱维译
    }
  }
}
const VUE_APP_ENV = process.env.VUE_APP_ENV || 'dev'
const CONFIG = (VUE_APP_ENV === 'pro') ? AllUrl[VUE_APP_ENV][enterpriseId] : AllUrl[VUE_APP_ENV]
export default CONFIG



// WEBPACK FOOTER //
// ./src/utils/config.js